module.exports = __webpack_public_path__ + "img/photo-04-1.f9bf8144.jpg";